import styled from "styled-components";

export const StatCard = styled.div`
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.tabBorderColor};
    background: ${({ theme }) => theme.playerContentBackground};
`;

export const StyledMainComponent = styled.div`
    width: 100%;
    flex-shrink: 0;    
`;

export const MainContent = styled.div`
    width: 100%;
    gap: 24px;
    display: flex;
    padding-bottom: 30px;
    flex-wrap: wrap;
`;

export const StatCardContent = styled.div`
    width: calc((100% - 54px) / 3);
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.tabBorderColor};
    background: ${({ theme }) => theme.playerContentBackground};   
    // @media(max-width: 991px){
    //     width: calc((100% - 48px) / 2);
    // }    
`;

export const Universalcontainer = styled.div`
    // width: 263px;
   height: 136px;
    display: inline-flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    width: calc(100% - 32px);
    margin: 0px 16px 16px;
    .universal-rating{
        display: flex;
        // width: 263px;
        justify-content: space-between;
        align-items: center;
        width: 95%;
    }
`